import { PointCloudObject } from "@/object-cache";
import { GUID } from "@faro-lotv/foundation";

export type OpacityStats = {
  /** The point density. */
  pointsPerPixel?: number;
  /** The opacity of the points. */
  opacity: number;
};

export type PointOpacityMap = Record<GUID, OpacityStats>;

/**
 * @param pointCloudObjects The point clouds to calculate stats for.
 * @returns Stats about the opacity of the point cloud points.
 */
export function calculatePointOpacity(
  pointCloudObjects: PointCloudObject[],
): PointOpacityMap {
  const map: PointOpacityMap = {};

  pointCloudObjects.forEach((pc) => {
    map[pc.iElement.id] = {
      pointsPerPixel: pc.userData.pointsPerPixel,
      opacity: pc.material.opacity,
    };
  });

  return map;
}
